import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "dashboarding-report",
    class: _normalizeClass(
      'dashboarding-details-container ' + [$setup.fullScreen ? 'full-screen' : '']
    )
  }, null, 2))
}